import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { PageHero } from "./About";
import { formatDate } from "@/lib/format";
import { Button } from "@/components/ui/button";

const CATEGORIES = ["Buying Guides", "Renting Guides", "Selling Guides", "Landlord Advice", "Property Investment", "Market Updates", "Property News"];

export default function Blog() {
  const [params, setParams] = useSearchParams();
  const category = params.get("category");
  const [data, setData] = useState(null);

  useEffect(() => {
    const q = new URLSearchParams();
    if (category) q.set("category", category);
    api.get(`/blog?${q.toString()}`).then((r) => setData(r.data)).catch(() => setData({ items: [] }));
  }, [category]);

  return (
    <div>
      <PageHero kicker="Property insights" title="Guides, advice & market news" subtitle="Expert guidance for buyers, tenants, landlords and investors." />
      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-14">
        <div className="flex gap-2 flex-wrap mb-8">
          <button onClick={() => setParams({})} className={`px-4 py-2 rounded-full text-sm font-semibold ${!category ? "bg-[#C81D35] text-white" : "bg-white border border-border"}`} data-testid="blog-cat-all">All</button>
          {CATEGORIES.map((c) => (
            <button key={c} onClick={() => setParams({ category: c })} className={`px-4 py-2 rounded-full text-sm font-semibold ${category === c ? "bg-[#C81D35] text-white" : "bg-white border border-border hover:border-[#C81D35]"}`} data-testid={`blog-cat-${c}`}>{c}</button>
          ))}
        </div>
        {data === null ? (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">{Array.from({ length: 3 }).map((_, i) => <div key={i} className="h-80 bg-muted rounded-2xl animate-pulse" />)}</div>
        ) : data.items.length === 0 ? (
          <div className="text-center py-20 text-muted-foreground" data-testid="blog-empty">No articles found in this category yet.</div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {data.items.map((p) => (
              <Link key={p.id} to={`/blog/${p.slug}`} className="group bg-white rounded-2xl border border-border overflow-hidden hover:shadow-lg transition-shadow" data-testid={`blog-post-${p.slug}`}>
                {p.image && <div className="aspect-[16/10] overflow-hidden"><img src={p.image} alt={p.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" /></div>}
                <div className="p-5">
                  <span className="text-xs font-semibold text-[#C81D35] uppercase tracking-wide">{p.category}</span>
                  <h3 className="mt-2 font-display text-lg font-bold text-[#111827] line-clamp-2 group-hover:text-[#C81D35] transition-colors">{p.title}</h3>
                  <p className="mt-2 text-sm text-muted-foreground line-clamp-2">{p.excerpt}</p>
                  <p className="mt-3 text-xs text-muted-foreground">{p.author} · {formatDate(p.published_at)}</p>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
